import { useEffect, useState } from "react";
import { BakeSessions } from "../model/bakeSessions";

export type BakeData = {
  isLoading: boolean;
  bakeSessions?: BakeSessions[];
};

const serverURL =
  process.env.REACT_APP_USE_REAL_BACKEND === "true"
    ? process.env.REACT_APP_REAL_BACKEND
    : process.env.REACT_APP_LOCAL_BACKEND;

const useSessionService = (bakeID: number) => {
  const [result, setResult] = useState<BakeData>({
    isLoading: true,
    bakeSessions: undefined,
  });

  useEffect(() => {
    async function fetchSessions() {
      const response = await fetch(`${serverURL}/sessions/${bakeID}`);
      const json = await response.json();
      if (json.length === 0) {
        setResult({ isLoading: false, bakeSessions: undefined });
      } else {
        setResult({ isLoading: false, bakeSessions: json });
      }
    }
    fetchSessions();
  }, [bakeID]);

  return result;
};

export default useSessionService;
